import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface AdminUser {
  id: string;
  email: string;
  full_name: string | null;
  avatar_url: string | null;
  last_sign_in_at: string | null;
  created_at: string;
  email_confirmed_at: string | null;
  workspace_count: number;
}

export function useAdminUsers() {
  return useQuery({
    queryKey: ["admin", "users"],
    queryFn: async (): Promise<AdminUser[]> => {
      const { data, error } = await supabase.functions.invoke(
        "admin-list-users",
        { body: { page: 1 } },
      );
      if (error) throw error;
      if (data?.error) throw new Error(data.error as string);
      return (data.users ?? []) as AdminUser[];
    },
  });
}
